import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

const DISMISSED_KEY = "ngx_install_dismissed_v1";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(DISMISSED_KEY)) return;
    if (window.matchMedia("(display-mode: standalone)").matches) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", handler);

    // iOS Safari has no install prompt — show hint instead
    const ua = navigator.userAgent;
    const isIOS = /iphone|ipad|ipod/i.test(ua);
    const isSafari = /safari/i.test(ua) && !/crios|fxios|edgios/i.test(ua);
    const isStandalone = window.navigator.standalone === true;
    if (isIOS && isSafari && !isStandalone) {
      setTimeout(() => { setIosHint(true); setVisible(true); }, 3000);
    }

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const choice = await deferred.userChoice;
    if (choice.outcome === "accepted") {
      localStorage.setItem(DISMISSED_KEY, "1");
    }
    setVisible(false);
    setDeferred(null);
  };

  const dismiss = () => {
    localStorage.setItem(DISMISSED_KEY, "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="install-prompt"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 sm:w-[360px] z-50 bg-slate-950 border border-cyan-500/30 cyan-glow p-4"
    >
      <button onClick={dismiss} className="absolute top-2 right-2 text-slate-500 hover:text-white" aria-label="Dismiss" data-testid="install-dismiss">
        <X size={14} />
      </button>
      <div className="label-mono text-cyan-400 mb-2">/ INSTALL APP</div>
      {iosHint ? (
        <>
          <div className="text-sm font-medium">Add Novagenix to your Home Screen</div>
          <p className="text-xs text-slate-400 mt-2 leading-relaxed">
            Tap the <span className="font-mono text-cyan-400">Share</span> button in Safari, then choose
            <span className="font-mono text-cyan-400"> &quot;Add to Home Screen&quot;</span>.
          </p>
        </>
      ) : (
        <>
          <div className="text-sm font-medium">Install Novagenix Labs</div>
          <p className="text-xs text-slate-400 mt-1.5 leading-relaxed">Faster checkout, offline catalog access, instant launch from your home screen.</p>
          <button
            onClick={install}
            data-testid="install-accept"
            className="mt-3 inline-flex items-center gap-2 bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-semibold px-4 py-2 text-sm w-full justify-center"
          >
            <Download size={14} /> Install app
          </button>
        </>
      )}
    </div>
  );
}
